/*
 *   File : holdings.js
 *   Author : https://evoqins.com
 *   Description : user holdings card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo, useEffect, useState } from "react";

// Components
import { PrimaryButton, SecondaryButton } from "../Buttons";

//styles
import styles from "../../Style/Component/card.module.scss";

function HoldingsCard(props) {

    const [data, setData] = useState(props.data);
    const id = props.data.type == "Fund" ? props.data.mf_id : props.data.goal_id;
    const selected_fund_id = props.selectedFund.type == "Fund" ? props.selectedFund.mf_id : props.selectedFund.goal_id;

    useEffect(() => {
        setData(props.data);
    }, [data]);

    return (
        props.isCardView ?
            <div className={`${styles.e_holdings_card} ${props.data.type === "External" ? "pe-none" : ""} ${props.data.type !== "External" && selected_fund_id === id ? "e-border-1px-egyptian-blue" : "border-transparent"} transition h-100 d-flex flex-column  gap-3 p-3 e-bg-cultured e-border-radius-16 cursor-pointer e-border-radius-16`} onClick={props.onClickCard}>
                {/* fund name */}
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-3 pe-lg-2">
                        <img className="w-40px width-24px-res h-100 object-fit-contain me-1 e-border-radius-10 e-bg-white p-1"
                            src={data.icon}
                            alt="holdings logo" />
                        <h2 className="e-ellipse e-text-onyx e-primary-font-inter e-font-12-res e-font-14-res-lg e-font-16 e-font-weight-400 line-height-20px mb-0">
                            {data.name}
                        </h2>
                    </div>
                    {/* {
                    props.type !== 2 &&
                    <img className="arrow-animation cursor-pointer"
                        src={RightBlackarrow}
                        alt="arrow right" />
                } */}
                </div>

                {/* Type of holding */}
                <div className="d-flex gap-2 align-items-center">
                    {
                        (data.tags || []).map((item, index) => (
                            <span key={index} className="e-text-html-css-gray e-primary-font-inter e-font-10-res e-font-12 e-font-weight-500 line-height-20px px-sm-2 px-1 e-border-radius-18 e-bg-white-marble">
                                {item}
                            </span>
                        ))
                    }
                </div>

                {/* Holdings details */}
                <div className="d-flex justify-content-between">
                    <div className="col-auto d-flex flex-column">
                        <span className="e-text-dark-heather e-primary-font-inter e-font-14-res  e-font-16 e-font-weight-400 line-height-22px">
                            Current
                        </span>
                        <span className="e-text-charleston-green e-primary-font-inter e-font-14-res e-font-16 e-font-weight-600 line-height-22px">
                            {data.current_amount_text}
                        </span>
                    </div>
                    <div className="col-auto d-flex flex-column text-end">
                        <span className="e-text-dark-heather e-primary-font-inter e-font-14-res e-font-16 e-font-weight-400 line-height-22px">
                            Invested
                        </span>
                        <span className="e-text-charleston-green e-primary-font-inter e-font-14-res  e-font-16 e-font-weight-600 line-height-22px">
                            {data.invested_amount_text}
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-between">
                    <div className="col-auto d-flex flex-column">
                        <span className="e-text-dark-heather e-primary-font-inter e-font-14-res  e-font-16 e-font-weight-400 line-height-22px">
                            Returns
                        </span>
                        <span className={`${data.returns_amount >= 0 ? "e-text-bottle-green" : "e-text-red"} d-flex flex-wrap e-primary-font-inter e-font-14-res e-font-16 e-font-weight-600 line-height-22px`}>
                            <span>
                                {data.returns_amount_text}
                            </span>
                            <span className="e-font-12-res e-font-14 ps-1">
                                ({data.returns_percentage_text})
                            </span>
                        </span>
                    </div>
                    {
                        data.xirr_text &&
                        <div className="col-auto d-flex flex-column text-end">
                            <span className="e-text-dark-heather e-primary-font-inter e-font-14-res e-font-16 e-font-weight-400 line-height-22px">
                                XIRR
                            </span>
                            <span className={`${data.xirr >= 0 ? "e-text-bottle-green" : "e-text-red"} e-primary-font-inter e-font-14-res  e-font-16 e-font-weight-600 line-height-22px`}>
                                {data.xirr_text}
                            </span>
                        </div>
                    }
                </div>

                {/* action buttons */}
                {
                    data.show_detail &&
                    <div className="d-flex gap-2 row-gap-3 flex-column flex-sm-row flex-nowrap align-items-center justify-content-end justify-content-lg-between justify-content-xl-end mt-auto">
                        <div className="col-12 col-sm-6 col-md-5">
                            <SecondaryButton name="Redeem"
                                disabled={data.current_amount > 0 ? false : true}
                                className="w-100 padding-12px-tb e-bg-lotion e-font-14 e-text-charleston-green e-border-bright-gray"
                                onPress={(e) => props.onRedeem(e, id, data.type)} />
                        </div>
                        <div className="col-12 col-sm-6 col-md-auto">
                            <PrimaryButton name="Invest more"
                                className="px-3 e-border-radius-24 w-100 e-font-14-res e-font-14 padding-12px-tb e-font-weight-600 text-nowrap"
                                onPress={(e) => props.onInvest(e, id, data.type)} />
                        </div>
                    </div>
                }
            </div>
            :
            <div className={`${styles.e_holdings_card} ${props.data.type === "External" ? "pe-none" : ""} ${props.data.type !== "External" && selected_fund_id === id ? "e-border-1px-egyptian-blue" : "border-transparent"} transition d-flex flex-column row-gap-2  p-3 e-bg-cultured e-border-radius-16 cursor-pointer`}
                onClick={props.onClickCard}>
                <div className="d-flex  gap-2 gap-xl-5 align-items-lg-center  row-gap-3">
                    <div className="d-flex align-items-start align-items-sm-center gap-2 gap-sm-3 flex-fill">
                        <img className="w-40px width-24px-res object-fit-contain h-auto me-1 e-border-radius-10 e-bg-white p-1"
                            src={data.icon}
                            alt="holdings logo" />
                        <h2 className="e-ellipse e-text-onyx e-primary-font-inter e-font-12-res  e-font-16 e-font-weight-400 line-height-20px mb-0">
                            {data.name}
                        </h2>
                    </div>
                    <div className="d-flex align-items-center gap-2 ms-lg-auto col-auto ps-4 ps-sm-5 ps-lg-0">
                        <span className="e-primary-font-inter e-font-14-res e-font-16 e-font-weight-700 line-height-22px">
                            <span className="e-text-bottle-green">
                                {data.current_amount_text}
                            </span>
                            <span className={`${data.returns_amount >= 0 ? "e-text-bottle-green" : "e-text-red"} e-font-weight-500`}>
                                ({data.returns_amount_text})
                            </span>
                        </span>
                    </div>
                </div>
                {/* Type of holding */}
                <div className="d-flex gap-2 align-items-center ms-4 ms-sm-5 ps-2">
                    {
                        (data.tags || []).map((item, index) => (
                            <span key={index} className="e-text-html-css-gray e-primary-font-inter e-font-10-res e-font-12 e-font-weight-500 line-height-20px px-sm-2 px-1 e-border-radius-18 e-bg-white-marble">
                                {item}
                            </span>
                        ))
                    }
                </div>
            </div>
    );
};

export default memo(HoldingsCard);